import axios from 'axios';
import {
  DEFAULT_PER_PAGE,
  DEFAULT_CURRENT_PAGE
} from 'pages/LearningResources/utils';

export function getViewingHistory(
  perPage: number = DEFAULT_PER_PAGE,
  currentPage: number = DEFAULT_CURRENT_PAGE,
  payload: {
    sort_by: string | undefined;
    sort_dir: 'asc' | 'desc' | undefined;
    query?: string | undefined;
    class_version?: string[] | undefined;
    age_level?: string[] | undefined;
    dimension?: string[] | undefined;
    language?: string | undefined;
  }
) {
  return axios.get(
    `/api/v2/learning_resources/history?per_page=${perPage}&page=${currentPage}`,
    {
      params: payload
    }
  );
}
